

// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import "../Categorys/categorys.scss";
// import axios from "axios";
// import { API_BASE_URL } from "../../../utils/index";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import { useAuthHeaders } from "../../../components/Token";
// import SubProductCategory from "../../Masters/SubProductCategory/SubProductCategory";
// import { BsThreeDotsVertical } from "react-icons/bs";
// import Dropdown from 'react-bootstrap/Dropdown';
// import { FcReading, FcEmptyTrash, FcOk } from "react-icons/fc";
// import EditSubCategory from "../SubCategorys/EditSubCategory/EditSubCategory"
// import { MdEdit } from "react-icons/md";
// function SubCategorys() {
//   const [data, setData] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const headers = useAuthHeaders();
//   const [editCategoryId, setEditCategoryId] = useState(null);
// console.log(headers,"headerDDDDDDDDDDDDDDDDDDDDDd")
//   const admin=localStorage.getItem("accessToken");

//   console.log("subcategory inside check admin token check",admin)
// console.log("subcategory check header working? ",headers)



//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/getallcategory`, { headers })
//       .then((response) => {
//         console.log(response.data.data, "Categories Data");
//         setCategories(response.data.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching category data:", error);
//       });

//     axios
//       .get(`${API_BASE_URL}/allsubcategory`, { headers })
//       .then((response) => {
//         console.log("Subcategories Data", response.data.data);
//         setData(response.data.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching subcategory data:", error);
//       });
//   }, []);

//   const deleteCategory = (Id) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "Are you sure you want to delete this Sub Category?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         axios
//           .delete(`${API_BASE_URL}/deletesubcategory/${Id}`, {
//             headers: {
//               ...headers, // Ensure existing headers are included
//             },
//           })
//           .then((res) => {
//             setData((prevData) => prevData.filter((item) => item._id !== Id));
//             console.log(res,"message>>>>>>>>>>>>>>>>>>>>>>")
//             console.log(res.data.data.message, "message>>>>>>>>>>>>>>>>>>>>>>");
//             Swal.fire({
//               title: "Deleted!",
//               text: res.data.data.message,
//               icon: "success",
//             });
//           })
//           .catch((error) => {
//             console.error("Error deleting subcategory:", error);
  
//             if (error.response) {
//               console.error("Response data:", error.response.data.message);
//               console.error("Response status:", error.response.status);
//             }
  
//             Swal.fire({
//               title: "Error",
//               text: "Failed to delete subcategory.",
//               icon: "error",
//             });
//           });
//       }
//     });
//   };
//   const handleCloseDetails = () => seteditproperty(false);
//   const handleShowedit = (categoryId) => {
//     setDetailsCategoryId(categoryId);
//     setShowDetailsModal(true);
//   };
//   const [showLoginModal, setShowLoginModal] = useState(false);
//   const [ editproperty,seteditproperty]=useState(false);
//   const [detailsCategoryId, setDetailsCategoryId] = useState(null);
//   return (
//     <div className="p-4">
//       <div className="d-flex justify-content-between my-2">
//         <h2 className="m-0 text-uppercase fs-5 fw-medium">Sub Categorys</h2>
//         <SubProductCategory show={showLoginModal} handleClose={() => setShowLoginModal(false)} />
//       </div>
//       <table className="categorys-table">
//         <thead>
//           <tr>
//             <th>Sub Property</th>
//             <th>Property</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {/* {data && data.length > 0 ? ( */}
//             {data.map((item, index) => (
//               <tr key={index}>
//                 <td>{item.subcategoryname}</td>
//                 <td>
//                   {item.category 
//                     ? categories.find(category => category._id === item.category._id)?.categoryname 
//                     : "No category"}
//                 </td>
//                 <td>
//                   <Dropdown>
//                     <Dropdown.Toggle className="btns border border-0 ">
//                       <BsThreeDotsVertical />
//                     </Dropdown.Toggle>
//                     <Dropdown.Menu>
//                       <Dropdown.Item>
//                         <Link to={`/subCategorysDetial/${item._id}`}>
//                           <button className="mx-1 border border-0 btnss">
//                             <FcReading className="m-2 fs-5 " /> View
//                           </button>
//                         </Link>
//                       </Dropdown.Item>
//                       <Dropdown.Item>
//                         <button
//                           className="mx-1 border border-0 btnss"
//                           onClick={() => deleteCategory(item._id)}
//                         >
//                           <FcEmptyTrash className="m-2 fs-5" /> Delete
//                         </button>
//                       </Dropdown.Item>
//                       <Dropdown.Item>
//                         <Link onClick={()=> handleShowedit(item._id) }>
//                           <button className="mx-1 border border-0 btnss">
//                             <MdEdit className="m-2 fs-5" /> Edit
//                           </button>
//                         </Link>
//                       </Dropdown.Item>
//                     </Dropdown.Menu>
//                   </Dropdown>
//                 </td>
//               </tr>
             
//             ))}
//             <EditSubCategory
//             show={editproperty}
//             handleClose={handleCloseDetails}
//             categoryId={detailsCategoryId}
//              />

//           {/* // ) : (
//           //   <tr>
//           //     <td colSpan="3">No subcategories found</td>
//           //   </tr>
//           // )} */}
//         </tbody>
//       </table>
//     </div>
//   );
// }

// export default SubCategorys;
// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import "../Categorys/categorys.scss";
// import axios from "axios";
// import { API_BASE_URL } from "../../../utils/index";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import { useAuthHeaders } from "../../../components/Token";
// import SubProductCategory from "../../Masters/SubProductCategory/SubProductCategory";
// import { BsThreeDotsVertical } from "react-icons/bs";
// import Dropdown from 'react-bootstrap/Dropdown';
// import { FcReading, FcEmptyTrash, FcOk } from "react-icons/fc";
// import EditSubCategory from "../SubCategorys/EditSubCategory/EditSubCategory"
// import { MdEdit } from "react-icons/md";
// import SubsubCategorysDetial from "./SubCategorysDetial/SubCategorysDetial";

// function SubCategorys() {
//   const [data, setData] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const headers = useAuthHeaders();
//   const [editCategoryId, setEditCategoryId] = useState(null);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showdetails, setShowdetails] = useState(false);
//   const [detailsCategoryId, setDetailsCategoryId] = useState(null);
//   const admin = localStorage.getItem("accessToken");
  
//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/getallcategory`, { headers })
//       .then((response) => {
//         setCategories(response.data.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching category data:", error);
//       });

//     axios
//       .get(`${API_BASE_URL}/allsubcategory`, { headers })
//       .then((response) => {
//         setData(response.data.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching subcategory data:", error);
//       });
//   }, []);

//   const deleteCategory = (Id) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "Are you sure you want to delete this Sub Category?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         axios
//           .delete(`${API_BASE_URL}/deletesubcategory/${Id}`, {
//             headers: {
//               ...headers,
//             },
//           })
//           .then((res) => {
//             setData((prevData) => prevData.filter((item) => item._id !== Id));
//             Swal.fire({
//               title: "Deleted!",
//               text: res.data.data.message,
//               icon: "success",
//             });
//           })
//           .catch((error) => {
//             console.error("Error deleting subcategory:", error);
//             Swal.fire({
//               title: "Error",
//               text: "Failed to delete subcategory.",
//               icon: "error",
//             });
//           });
//       }
//     });
//   };

//   const handleShowEdit = (categoryId) => {
//     setEditCategoryId(categoryId);
//     setShowEditModal(true);
//   };

//   const showsubProperty =(categoryId)=>{
//     setShowdetails(true)
//     setDetailsCategoryId(categoryId);
//   }

//   const handleCloseEdit = () => {
//     setShowEditModal(false);
//     setEditCategoryId(null);
//   };
//   const [showLoginModal, setShowLoginModal] = useState(false)
//   return (
//     <div className="p-4">
//       <div className="d-flex justify-content-between my-2">
//         <h2 className="m-0 text-uppercase fs-5 fw-medium">Sub Categorys</h2>
//         <SubProductCategory show={showLoginModal} handleClose={() => setShowLoginModal(false)} />
//       </div>
//       <table className="categorys-table">
//         <thead>
//           <tr>
//             <th>Sub Property</th>
//             <th>Property</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((item, index) => (
//             <tr key={index}>
//               <td>{item.subcategoryname}</td>
//               <td>
//                 {item.category 
//                   ? categories.find(category => category._id === item.category._id)?.categoryname 
//                   : "No category"}
//               </td>
//               <td>
//                 <Dropdown>
//                   <Dropdown.Toggle className="btns border border-0 ">
//                     <BsThreeDotsVertical />
//                   </Dropdown.Toggle>
//                   <Dropdown.Menu>
//                     <Dropdown.Item>
//                       <Link >
//                         <button className="mx-1 border border-0 btnss"  onClick={()=> showsubProperty(item._id)}>
//                           <FcReading className="m-2 fs-5 " /> View
//                         </button>
//                       </Link>
//                     </Dropdown.Item>
//                     <Dropdown.Item>
//                       <button
//                         className="mx-1 border border-0 btnss"
//                         onClick={() => deleteCategory(item._id)}
//                       >
//                         <FcEmptyTrash className="m-2 fs-5" /> Delete
//                       </button>
//                     </Dropdown.Item>
//                     <Dropdown.Item>
//                       <button
//                         className="mx-1 border border-0 btnss"
//                         onClick={() => handleShowEdit(item._id)}
//                       >
//                         <MdEdit className="m-2 fs-5" /> Edit
//                       </button>
//                     </Dropdown.Item>
//                   </Dropdown.Menu>
//                 </Dropdown>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       <EditSubCategory
//         show={showEditModal}
//         handleClose={handleCloseEdit}
//         categoryId={editCategoryId}
//       />
//       <SubsubCategorysDetial
//       show={showdetails}
//       handleClose={showsubProperty}
//       categoryId={detailsCategoryId}
//       />
//     </div>
//   );
// }

// export default SubCategorys;
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../Categorys/categorys.scss";
import axios from "axios";
import { API_BASE_URL } from "../../../utils/index";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { useAuthHeaders } from "../../../components/Token";
import SubProductCategory from "../../Masters/SubProductCategory/SubProductCategory";
import { BsThreeDotsVertical } from "react-icons/bs";
import Dropdown from 'react-bootstrap/Dropdown';
import { FcReading, FcEmptyTrash, FcOk } from "react-icons/fc";
import EditSubCategory from "../SubCategorys/EditSubCategory/EditSubCategory";
import { MdEdit } from "react-icons/md";
import SubsubCategorysDetial from "./SubCategorysDetial/SubCategorysDetial";

function SubCategorys() {
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const headers = useAuthHeaders();
  const [editCategoryId, setEditCategoryId] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showdetails, setShowdetails] = useState(false);
  const [detailsCategoryId, setDetailsCategoryId] = useState(null);
  const admin = localStorage.getItem("accessToken");

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/getallcategory`, { headers })
      .then((response) => {
        setCategories(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching category data:", error);
      });

    axios
      .get(`${API_BASE_URL}/allsubcategory`, { headers })
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching subcategory data:", error);
      });
  }, [headers]);

  const deleteCategory = (Id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to delete this Sub Category?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${API_BASE_URL}/deletesubcategory/${Id}`, {
            headers: {
              ...headers,
            },
          })
          .then((res) => {
            setData((prevData) => prevData.filter((item) => item._id !== Id));
            Swal.fire({
              title: "Deleted!",
              text: res.data.data.message,
              icon: "success",
            });
          })
          .catch((error) => {
            console.error("Error deleting subcategory:", error);
            Swal.fire({
              title: "Error",
              text: "Failed to delete subcategory.",
              icon: "error",
            });
          });
      }
    });
  };

  const handleShowEdit = (categoryId) => {
    setEditCategoryId(categoryId);
    setShowEditModal(true);
  };

  const showsubProperty = (categoryId) => {
    setShowdetails(true);
    setDetailsCategoryId(categoryId);
  };

  const handleCloseEdit = () => {
    setShowEditModal(false);
    setEditCategoryId(null);
  };

  const handleCloseDetails = () => {
    setShowdetails(false);
    setDetailsCategoryId(null);
  };

  const [showLoginModal, setShowLoginModal] = useState(false);
  return (
    <div className="p-4">
      <div className="d-flex justify-content-between my-2">
        <h2 className="m-0  fs-5 fw-medium">List of  Property Type </h2>
        <SubProductCategory show={showLoginModal} handleClose={() => setShowLoginModal(false)} />
      </div>
      <table className="categorys-table">
        <thead>
          <tr>
            <th> Property Type</th>
            <th>Type</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item.subcategoryname}</td>
              <td>
                {item.category 
                  ? categories.find(category => category._id === item.category._id)?.categoryname 
                  : "No category"}
              </td>
              <td>
                <Dropdown>
                  <Dropdown.Toggle className="btns border border-0 ">
                    <BsThreeDotsVertical />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item>
                      <button className="mx-1 border border-0 btnss" onClick={() => showsubProperty(item._id)}>
                        <FcReading className="m-2 fs-5 " /> View
                      </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <button
                        className="mx-1 border border-0 btnss"
                        onClick={() => deleteCategory(item._id)}
                      >
                        <FcEmptyTrash className="m-2 fs-5" /> Delete
                      </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <button
                        className="mx-1 border border-0 btnss"
                        onClick={() => handleShowEdit(item._id)}
                      >
                        <MdEdit className="m-2 fs-5" /> Edit
                      </button>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <EditSubCategory
        show={showEditModal}
        handleClose={handleCloseEdit}
        categoryId={editCategoryId}
      />
      <SubsubCategorysDetial
        show={showdetails}
        handleClose={handleCloseDetails}
        categoryId={detailsCategoryId}
      />
    </div>
  );
}

export default SubCategorys;
